import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BunnySisterBrandSection = () => {
  const navigate = useNavigate();

  return (
    <section className="section-spacing bg-gradient-to-br from-pink-50 via-yellow-50 to-pink-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side */}
          <div>
            <div className="mb-6">
              <span className="text-sm font-sans font-bold tracking-widest text-gray-600">OUR SISTER BRAND</span>
              <h2 className="text-5xl font-serif bunny-headline text-gray-900 mt-3 mb-4">
                Meet Waisted Momma
              </h2>
              <div className="bunny-divider"></div>
            </div>
            
            <p className="text-lg text-gray-700 font-sans leading-relaxed mb-6">
              Looking for body-positive, empowering shapewear with a focus on comfort and support? Our sister brand <span className="font-bold">Waisted Momma</span> celebrates real women, real bodies, and real transformation.
            </p>

            <div className="space-y-3 mb-8">
              <div className="flex items-start gap-3">
                <Heart className="w-5 h-5 bunny-accent-pink flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-sans font-bold text-gray-900 mb-1">Body-Positive Philosophy</h4>
                  <p className="text-sm text-gray-600">Designed for moms and women on self-improvement journeys</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Heart className="w-5 h-5 bunny-accent-pink flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-sans font-bold text-gray-900 mb-1">Comfort First</h4>
                  <p className="text-sm text-gray-600">Premium support without sacrificing all-day comfort</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Heart className="w-5 h-5 bunny-accent-pink flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-sans font-bold text-gray-900 mb-1">Empowering Community</h4>
                  <p className="text-sm text-gray-600">Join thousands of women supporting each other</p>
                </div>
              </div>
            </div>

            <button 
              onClick={() => navigate('/')}
              className="bunny-btn-secondary px-8 py-4 font-sans flex items-center gap-3"
            >
              Visit Waisted Momma
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>

          {/* Right side */}
          <div className="bunny-card p-10 bg-white">
            <h3 className="text-3xl font-serif bunny-headline text-gray-900 mb-6">
              Two Brands, One Mission
            </h3>
            <p className="text-base text-gray-700 font-sans leading-relaxed mb-6">
              Whether you're drawn to the <span className="font-bold bunny-accent-pink">bold, fashion-forward</span> energy of Waisted Bunny or the <span className="font-bold">empowering, body-positive</span> philosophy of Waisted Momma, we're here to support your confidence journey.
            </p>
            <div className="bg-gradient-to-r from-pink-100 to-yellow-100 p-6 border-l-4 border-pink-400">
              <p className="text-base text-gray-900 font-sans font-bold">
                Same premium quality. Same commitment to your confidence. Different vibes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BunnySisterBrandSection;
